<template>
  <div class="student-card">
    <div
      class="student-card__avatar"
      :class="{ 'student-card__avatar--empty': !member.avatar }"
    >
      <img
        v-if="member.avatar"
        class="student-card__avatar-img"
        :src="member.avatar"
        alt=""
      >
      <span
        v-else
        class="student-card__initials"
      >{{ initials }}</span>
    </div>

    <div class="student-card__info">
      <h3 class="student-card__name">{{ member.full_name }}</h3>
      <p class="student-card__meta">
        Age {{ member.extra_user_info.age }} · Born {{ member.extra_user_info.birth_date }}
      </p>
      <button
        type="button"
        class="student-card__photo-link"
        @click="$refs.refInputEl.click()"
      >
        {{ member.avatar ? 'Change photo' : 'Add photo' }}
      </button>
      <input
        type="file"
        ref="refInputEl"
        accept=".jpg, .png, .gif"
        hidden
        @input="handleFileUpload"
      >
    </div>
  </div>
</template>

<script>
import useFamily from '@/views/Family/useFamily'

export default {
  name: 'StudentCard',
  props: {
    member: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { updateMemberInfo } = useFamily()
    return { updateMemberInfo }
  },
  computed: {
    initials() {
      const name = this.member.full_name || ''
      return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0].toUpperCase())
        .join('')
    },
  },
  methods: {
    handleFileUpload(e) {
      const file = e.target.files[0]
      const reader = new FileReader()

      reader.addEventListener(
        'load',
        () => {
          this.member.avatar = reader.result
          this.updateMemberAvatar()
        },
        false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    async updateMemberAvatar() {
      const queryParams = {
        logoUploaded: this.member.avatar,
      }
      await this.updateMemberInfo(this.member.id, queryParams)
    },
  },
}
</script>

<style scoped>

</style>

